import * as React from 'react';
import ListAltIcon from '@material-ui/icons/ListAlt';
import { fetchQuestionnaireStatus, selectQuestionnaireProgress } from '@pec/aion-ui-core/slices/questionnaireStatus';
import { selectIsChasContractor } from '@pec/aion-ui-core/selectors/organization';
import { ToDoDescriptor } from '../types';
import { useAppDispatch, useTypedSelector } from '../../../../combineReducers';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type RouteParams = {
  organizationId: string;
};

export const useCompleteQuestionnaireToDo = (): ToDoDescriptor[] => {
  const dispatch = useAppDispatch();
  const { organizationId } = useParams<RouteParams>();
  const { t } = useTranslation('subscriber');

  const isChas = useTypedSelector(selectIsChasContractor);
  const { isFetching, requiredQuestionsCount } = useTypedSelector(state => state.questionnaireStatus);
  const { publishedProgress } = useTypedSelector(selectQuestionnaireProgress);

  React.useEffect(() => {
    if (organizationId && !isChas) {
      dispatch(fetchQuestionnaireStatus({ organizationId }));
    }
  }, [organizationId, isChas, dispatch]);

  // requiredQuestionsCount === 0 yields publishedProgress === 0, so guard against showing the item
  // to a contractor who has nothing required to complete.
  const isIncomplete = requiredQuestionsCount > 0 && publishedProgress < 100;

  return [
    {
      id: 'completeQuestionnaire',
      variant: 'link',
      label: t('newDashboard.toDoWidget.completeQuestionnaire', 'Complete questionnaire'),
      icon: <ListAltIcon />,
      href: `/organizations/${organizationId}/questionnaire-v2`,
      isVisible: !isChas && isIncomplete,
      isFetching
    }
  ];
};
